import { FC } from 'react';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import {
    capitalizeFirstLetter,
    getTagVariant,
    hideCardNumber,
    prettifyCardStatus,
    prettifyCardType
} from '@utils/index';
import { Icon } from '@components/icons';
import Status from '@components/common/status';
import xepptCard from '@svg/xeppt_card.svg';
import frozenMask from '@svg/frozen_card.svg';
import { ECardStatus, TCardLite } from '@xeppt/xeppt-sdk/types/card';

interface IProps {
    card: TCardLite;
    onClick?: () => void;
}

const CardRow: FC<IProps> = ({ card, onClick }) => {
    return (
        <button
            className={styles.wrapper}
            onClick={() => {
                if (onClick) onClick();
            }}>
            <div className={styles.left}>
                <div className={styles.content}>
                    <div
                        className={`${styles.card_image} ${card.status !== ECardStatus.ACTIVE && card.status !== ECardStatus.FREEZED ? styles.disabled : ''}`}
                        style={{ backgroundImage: `url(${xepptCard})` }}>
                        {card.status === ECardStatus.FREEZED && (
                            <img className={styles.frozen_mask} src={frozenMask} />
                        )}
                    </div>
                    <div className={styles.text_wrapper}>
                        <Typography variant="body1">
                            <>
                                <span>{capitalizeFirstLetter(prettifyCardType(card?.type))}</span>{' '}
                                {hideCardNumber(card.card_number, 'full')}
                            </>
                        </Typography>
                        <Status
                            className={styles.mobile_status}
                            type="text"
                            variant={getTagVariant(card.status)}>
                            {capitalizeFirstLetter(prettifyCardStatus(card.status))}
                        </Status>
                    </div>
                </div>
                <Status className={styles.status} variant={getTagVariant(card.status)}>
                    {capitalizeFirstLetter(prettifyCardStatus(card.status))}
                </Status>
            </div>
            <Icon name="nav_right" />
        </button>
    );
};

export default CardRow;
